import React from 'react';
import { LicensingContentBody } from '../../components/data/data/HelpCenter/Licensing';
import ArticleLayout from '../../components/HelpCenterComponents/ArticleLayout';

// Define article configuration
const ARTICLE_TITLES = [
  'Spatial Grid Licensing & Subscription Programs',
  'Licensing Model Overview',
  'Single User Monthly Subscription',
  'Single User Annual Subscription',
  'Multi User Annual Subscription',
  'Three-Year Enterprise Subscription Program',
  'Designed for Enterprise Adoption',
  'Get in Touch',
];

// Define table of contents for each article
const TOC_DATA = {
  0: ['Spatial Grid Licensing & Subscription Programs'],
  1: ['Licensing Model Overview'],
  2: ['Single User Monthly Subscription'],
  3: ['Single User Annual Subscription'],
  4: ['Multi User Annual Subscription'],
  5: ['Three-Year Enterprise Subscription Program'],
  6: ['Designed for Enterprise Adoption'],
  7: ['Get in Touch'],
};

const LicensingArticles = () => {
  return (
    <ArticleLayout
      articleTitles={ARTICLE_TITLES}
      tocData={TOC_DATA}
      ContentBodyComponent={LicensingContentBody}
      sectionName="Licensing"
      searchPlaceholder="Search the Spatial Grid Help Center"
      showUseCases={true}
      showTitle={false}
    />
  );
};

export default LicensingArticles;
